import { Navigate, Outlet, RouteObject } from "react-router";
import { htzOffersRoutes } from "@/routes/processes/[processId]/htz/offers/offers-routes";
import OverviewRoute from "@/routes/processes/[processId]/htz/overview/overview";
import ContactRoute from "@/routes/processes/[processId]/htz/contact/contact";
import OffersRoute from "@/routes/processes/[processId]/htz/offers/offers-route";
import OrdersRoute from "@/routes/processes/[processId]/htz/orders/orders-route";
import { htzOrdersRoutes } from "@/routes/processes/[processId]/htz/orders/orders-routes";
import ConfirmationsRoute from "@/routes/processes/[processId]/htz/confirmations/confirmations-route";
import { htzConfirmationsRoutes } from "@/routes/processes/[processId]/htz/confirmations/confirmations-routes";
import { htzWorkOrdersRoutes } from "@/routes/processes/[processId]/htz/work-orders/work-order-routes";
import { WorkOrdersRoute } from "@/routes/processes/[processId]/htz/work-orders/work-orders-route";
import { ReportsRoute } from "@/routes/processes/[processId]/htz/reports/reports-route";
import { htzReportsRoutes } from "@/routes/processes/[processId]/htz/reports/reports-routes";
import { htzCommitmentsRoutes } from "@/routes/processes/[processId]/htz/commitments/commitments-routes";
import { ProcessConfiguredGuard } from "../_components/process-configured-guard";

export const htzRoutes: RouteObject[] = [
  {
    element: <Navigate to="overview" replace />,
    index: true,
  },
  {
    path: "overview",
    element: <OverviewRoute />,
  },
  {
    path: "contact",
    element: <ContactRoute />,
  },
  // The following routes require a fully configured process.
  // The elements are wrapped with an appropriate guard, to
  // notify the user.
  ...[
    {
      path: "offers",
      element: <OffersRoute />,
      children: htzOffersRoutes,
    },
    {
      path: "orders",
      element: <OrdersRoute />,
      children: htzOrdersRoutes,
    },
    {
      path: "confirmations",
      element: <ConfirmationsRoute />,
      children: htzConfirmationsRoutes,
    },
    {
      path: "commitments",
      element: <Outlet />,
      children: htzCommitmentsRoutes,
    },
    {
      path: "work-orders",
      element: <WorkOrdersRoute />,
      children: htzWorkOrdersRoutes,
    },
    {
      path: "reports",
      element: <ReportsRoute />,
      children: htzReportsRoutes,
    },
  ].map((route) => ({
    ...route,
    element: <ProcessConfiguredGuard>{route.element}</ProcessConfiguredGuard>,
  })),
];
